import { initializeApp } from "firebase/app";
import {
    getAuth,
    GoogleAuthProvider,
    // EmailAuthProvider,
    onAuthStateChanged,
    type User,
    signOut,
} from "firebase/auth";
import {
    getFirestore,
    doc,
    getDoc,
    runTransaction,
    serverTimestamp,
    collection, addDoc, query, orderBy, limit, getDocs,
    setDoc,
    deleteDoc,
    QueryDocumentSnapshot,
    type DocumentData,
    Query,
    startAfter
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject, getStorage } from "firebase/storage";
import * as firebaseui from "firebaseui";
// @ts-ignore
import "firebaseui/dist/firebaseui.css";
import { initTagInput } from "./TagInput";
import { $btn, $class, $div, $dlg, $inp, appManager, assert, clearThumbnailBlob, downloadMarkdownFile, hideHtml, makeArticleBox, msg, MyError, showHtml, showToast, thumbnailBlob, type AbstractArticle } from "webgpu-sims";
import { initArticle, makeArticleData, makeContentText } from "./article";
import { cmpAppManager } from "./main";
import { initComboBox } from "./ComboBox";

// -------------------------------------------------------------
// 1. Firebase 初期化
// -------------------------------------------------------------
let firebaseConfig : any;

if (location.hostname == "gpusims.com" || !location.href.endsWith("?dev")) {
    firebaseConfig = {
        apiKey: "AIzaSyAXx3bVV-cJLR5FFg3xsb6BHK9U7ufMnag",
        authDomain: "gpusims.firebaseapp.com",
        projectId: "gpusims",
        storageBucket: "gpusims.firebasestorage.app",
        messagingSenderId: "351327742687",
        appId: "1:351327742687:web:e76c82c1accf432428976a",
        measurementId: "G-C81XLP99XH"
    };

}
else {

    firebaseConfig = {
        apiKey: "AIzaSyD0mb_UHXHDT7216GgNyKniDH7YUEcTnyY",
        authDomain: "gpusims-dev.firebaseapp.com",
        projectId: "gpusims-dev",
        storageBucket: "gpusims-dev.firebasestorage.app",
        messagingSenderId: "54373878398",
        appId: "1:54373878398:web:d44502f0ad8dea6407262f",
        measurementId: "G-C1QJ66WB64"
    };
}

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
export const storage = getStorage(app);

let theUser: User | null = null;
let publicId: string | null;

export let theArticles: ArticleData[] = [];
let theArticle : ArticleData | undefined;

let lastVisibleDocument: QueryDocumentSnapshot<DocumentData, DocumentData> | undefined;

function showHideDeletePublish(){
    let display_delete  : string = "none";
    let display_publish : string = "none";
    if(publicId != null){
       if(theArticle == undefined || theArticle.authorId == publicId){
            display_publish = "inline-block";
       }
       if(theArticle != undefined && theArticle.authorId == publicId){
            display_delete = "inline-block";
       }
    }

    $btn("delete-btn").style.display  = display_delete;
    $btn("publish-btn").style.display = display_publish;
}

export function setArticle(article: ArticleData | undefined) {
    theArticle = article;
    if(article == undefined){
        clearThumbnailBlob();
    }
    msg(`article author:${theArticle ? theArticle.authorId : "none"}`);

    showHideDeletePublish();
}

export function getPublicId(): string {
    assert(publicId != null);
    return publicId!;
}


// -------------------------------------------------------------
// 3. 認証状態の監視 (Single Source of Truth)
// -------------------------------------------------------------
onAuthStateChanged(auth, async (user: User | null) => {
    $dlg("sign-in-dlg").close();

    theUser = user;
    publicId = null;
    if (user) {
        try {

            // ★ 1. Firestore からデータを取得（ここでエラーが起きやすいです）
            const userRef = doc(db, "users", user.uid);
            const userSnap = await getDoc(userRef);

            // ★ 2. 取得に成功したら画面を切り替える
            if (userSnap.exists()) {
                publicId = userSnap.data().publicId;
            }

            if (publicId == null) {
                $dlg("nickname-dlg").showModal();
            }
            else {
            }
            msg(`auth login id:${user.uid} public-id:${publicId}`);
        }
        catch (error) {
            // ★ 3. エラーが発生した場合、原因を画面に赤く表示する
            console.error("Firestore error:", error);
        }
    }
    else {
        // 未ログイン時はログイン画面を表示
        startFirebaseUI();
    }

    if (user) {
        // 【A】 サインイン済みの場合
        $class("log-in-btn").forEach(x => hideHtml(x));
        $class("log-in").forEach(x => showHtml(x));
        if (publicId) {

            $class("public-user-id").forEach(x => x.textContent = publicId);
        }
        else {
            $class("public-user-id").forEach(x => hideHtml(x));
        }
    }
    else {
        // 【B】 サインインしていない（または初期設定前）の場合

        $class("log-in-btn").forEach(x => showHtml(x));
        $class("log-in").forEach(x => hideHtml(x));
    }

    showHideDeletePublish();
});

// -------------------------------------------------------------
// 4. FirebaseUI の起動
// -------------------------------------------------------------
function startFirebaseUI() {
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth);

    ui.start("#firebaseui-auth-container", {
        // ★ 追加：サインインフローをポップアップ方式に強制する
        signInFlow: 'popup',

        signInOptions: [
            GoogleAuthProvider.PROVIDER_ID,
            // EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD
        ],
        callbacks: {
            // ログイン成功時に自動リダイレクトするのを防ぐ
            signInSuccessWithAuthResult: () => false
        }
    });
}

async function onRegisterNicknameBtn() {
    const btn = $btn("nickname-btn");

    if (theUser == null) {
        throw new MyError("user is null");
    }

    const desiredNickname = $inp("nickname-inp").value.trim();
    if (desiredNickname == "") {
        showToast("Please enter your nickname.");
        return;
    }

    btn.disabled = true;
    showToast("Registering...");

    const profileRef = doc(db, "profiles", desiredNickname);
    const userRef = doc(db, "users", theUser.uid);

    try {
        await runTransaction(db, async (transaction) => {
            if (theUser == null) {
                throw new MyError("user is null");
            }

            const profileDoc = await transaction.get(profileRef);

            if (profileDoc.exists()) {
                showToast("This nickname is already taken. Please choose another one.");
            }
            else{

                // 新規登録 (displayName はGoogleアカウント名などを初期値に使用)
                transaction.set(profileRef, {
                    displayName: theUser.displayName || "Anonymous User",
                    iconUrl: theUser.photoURL || "",
                    createdAt: serverTimestamp()
                });

                transaction.set(userRef, {
                    publicId: desiredNickname,
                    email: theUser.email || ""
                });

                showToast("Nickname set successfully.");

                $dlg("nickname-dlg").close();
            }
        });

        // トランザクション成功：
        // Firestoreの更新後、状態をMAIN_APPへ移行
    } catch (error: any) {
        showToast(`An error occurred. Please try again.\n${error.message}`);
        console.error("Transaction failed: ", error);
    }

    btn.disabled = false;
}

async function onCancelNicknameDlg(_: Event){
    await signOut(auth);
}


export interface CreateArticleParams {
    authorId: string;
    title: string;
    tags: string[];
    ai : string,
    contentText: string;                // アプリ内のテキストデータを受け取る
}


export async function createArticle(params: CreateArticleParams): Promise<string> {
    const {
        authorId,
        title,
        tags,
        ai,
        contentText,
    } = params;

    // アップロード成功後に保持しておくStorageの参照（ロールバック用）
    const uploadedRefs: ReturnType<typeof ref>[] = [];

    try {
        const timestamp = Date.now();

        let thumbnailPath : string;
        let thumbnailUrl : string;

        if(thumbnailBlob != undefined){

            // 1. Canvasから画像Blobを生成し、Cloud Storage にアップロード
            thumbnailPath = `thumbnails/${authorId}/${timestamp}_thumbnail.jpg`;
            const thumbnailRef = ref(storage, thumbnailPath);

            showToast("uploading the thumbnail image...", 10);
            await uploadBytes(thumbnailRef, thumbnailBlob);
            uploadedRefs.push(thumbnailRef); // 成功したらロールバック対象に追加
            thumbnailUrl = await getDownloadURL(thumbnailRef);
        }
        else{
            if(theArticle == undefined){
                throw new MyError("Article is undefined");
            }

            thumbnailPath = theArticle.thumbnailPath;
            thumbnailUrl = theArticle.thumbnailUrl;
            assert(thumbnailPath != undefined && thumbnailUrl != undefined);
        }

        // 2. テキストデータからBlobを生成し、Cloud Storage にアップロード
        // 拡張子は .txt や独自のもの（.note など）適宜変更してください
        const contentBlob = new Blob([contentText], { type: "text/plain;charset=utf-8" });
        const contentPath = `contents/${authorId}/${timestamp}_content.txt`;
        const contentRef = ref(storage, contentPath);

        showToast("uploading the article text...", 10);
        await uploadBytes(contentRef, contentBlob);
        uploadedRefs.push(contentRef); // 成功したらロールバック対象に追加
        const contentFileUrl = await getDownloadURL(contentRef);

        // 3. Firestore に記事データを保存
        const articleData = {
            authorId,
            title,
            tags,
            ai,
            thumbnailPath,
            thumbnailUrl,
            contentPath,
            contentFileUrl,
            likeCount: 0,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
        };

        showToast("writing the database...", 10);
        if (theArticle == undefined) {

            const docRef = await addDoc(collection(db, "articles"), articleData);
            showToast("create Article OK");

            msg(`create Article OK`);
            return docRef.id;
        }
        else {
            const docRef = doc(db, "articles", theArticle.id);
            await setDoc(docRef, articleData);
            showToast("update Article OK");

            msg(`update Article OK:[${contentFileUrl}]`);
            return docRef.id;
        }
    }
    catch (error) {
        console.error("Failed to post the article.:", error);

        // 【疑似ロールバック】Firestoreの保存に失敗した場合、アップロード済みのファイルを削除
        if (uploadedRefs.length > 0) {
            console.log("Attempting to roll back (delete) uploaded files...");
            // deleteObject を並列で実行し、エラーが起きても握りつぶす（本処理のエラーを優先するため）
            await Promise.allSettled(
                uploadedRefs.map((storageRef) => deleteObject(storageRef))
            );
            console.log("Rollback completed successfully.");
        }

        throw new Error("Failed to post the article.");
    }
}

export async function getArticle(articleId: string){
    try{
        const docRef = doc(db, "articles", articleId);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
            showToast(`Article not found.${articleId}`);
            return undefined;
        }

        const article = docSnap.data() as ArticleData;
        article.id = articleId;

        return article;
    }
    catch (error) {
        throw new MyError(`Failed to get the article.[${articleId}] ${error}`);
    }
}

/**
 * Deletes an article from Firestore and removes its associated files from Cloud Storage.
 * @param articleId The ID of the article document to delete.
 */
export async function deleteArticle(articleId: string): Promise<void> {
    try {
        const docRef = doc(db, "articles", articleId);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
            throw new MyError(`Article not found.${articleId}`);
        }

        const data = docSnap.data();

        // 1. Prepare to delete associated files from Cloud Storage
        const filesToDelete: Promise<void>[] = [];
        
        if (data.thumbnailPath) {
            const thumbnailRef = ref(storage, data.thumbnailPath);
            filesToDelete.push(deleteObject(thumbnailRef));
        }
        
        if (data.contentPath) {
            const contentRef = ref(storage, data.contentPath);
            filesToDelete.push(deleteObject(contentRef));
        }

        // Execute storage deletions in parallel
        // Using allSettled so if a file is already missing, it doesn't block the document deletion
        if (filesToDelete.length > 0) {
            msg("Deleting associated files from Storage...");
            await Promise.allSettled(filesToDelete);
        }

        // 2. Delete the document from Firestore
        await deleteDoc(docRef);
        msg(`Article ${articleId} successfully deleted.`);
    } 
    catch (error) {
        throw new MyError(`Failed to delete the article.${error}`);
    }
}

// 取得する記事データの型定義（必要に応じて拡張してください）
export interface ArticleData extends AbstractArticle {
    thumbnailPath : string;
    contentPath   : string;
    contentFileUrl: string;
    tags: string[];
    likeCount: number;
    createdAt: any; // Timestamp
    updatedAt: any; // Timestamp
}

/**
 * カテゴリーとキーワードで記事を検索し、最新20件を取得する
 * @param searchTag 検索する単語（完全一致）
 * @returns 検索結果の記事配列
 */
export async function fetchLatestArticlesByKeyword(all:boolean): Promise<ArticleData[]> {
    // searchTag: string
    try {
        const articlesRef = collection(db, "articles");

        // クエリの構築
        let q: Query<DocumentData, DocumentData>;
        if(all){

            q = query(articlesRef);
        }
        else if(lastVisibleDocument == undefined){
            q = query(
                articlesRef,
                //   where("tags", "array-contains", searchTag), // 配列内にキーワードが含まれるか
                orderBy("updatedAt", "desc"),                   // 更新日時の降順
                limit(10)                                       // 20件取得
            );
        }
        else{
            
            q = query(
                articlesRef,
                //   where("tags", "array-contains", searchTag), // 配列内にキーワードが含まれるか
                orderBy("updatedAt", "desc"),                   // 更新日時の降順
                startAfter(lastVisibleDocument),
                limit(5)                                       // 20件取得
            );
        }


        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            console.log("これ以上データはありません");
            // これ以上のリクエストを防ぐためnullにする
            lastVisibleDocument = undefined;
            return [];
        }

        lastVisibleDocument = querySnapshot.docs[querySnapshot.docs.length - 1];        

        // 取得したドキュメントを配列にマッピング
        const articles: ArticleData[] = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...(doc.data() as Omit<ArticleData, "id">)
        }));

        return articles;

    } catch (error) {
        console.error("Error occurred while searching for articles:", error);
        throw new Error("Failed to fetch articles.");
    }
};

function startObserve(target:HTMLElement) {
    // 1. 動作のオプションを設定する
    const options = {
        root: null,        // 基準となる要素（nullならブラウザの画面全体）
        rootMargin: '0px', // 判定領域を広げたり狭めたりする
        threshold: 0       // 要素がどれくらい見えたら反応するか（0は1pxでも見えたら、1は完全に見えたら）
    };

    // 2. 交差した（画面に入った/出た）時に実行されるコールバック関数
    const callback : IntersectionObserverCallback = async (entries, observer) => {
        for(const entry of entries){
            // entry.isIntersecting が true なら画面に入った、false なら画面から出た
            if (entry.isIntersecting) {
                msg(`要素が画面に入りました！[${entry}]`);

                // ここでFirestoreの追加読み込み関数を呼ぶ！
                await getContents();

                // ※1回だけ実行したい場合は監視を解除する
                observer.unobserve(entry.target);

                target.remove();
            }
        }
    };

    // 3. オブザーバー（監視者）を作成し、監視対象をセットする
    const observer = new IntersectionObserver(callback, options);

    // リストの一番下に配置した「検知用の透明な要素」などを指定
    observer.observe(target); // 監視スタート！
}

export async function getContents(all:boolean = false) {
    const articles =  await fetchLatestArticlesByKeyword(all);
    if(articles.length == 0){
        return;
    }

    theArticles.push(...articles);

    const div = $div("articles");
    for (const [idx, doc] of articles.entries()) {
        makeArticleBox(div, idx, doc, cmpAppManager);
        // msg(`doc:${doc.id} ${doc.title}`);
    }

    const sp = document.createElement("span");
    sp.textContent = "@";
    div.append(sp);

    startObserve(sp);
}

// ログアウトボタンのイベントリスナー
for(const btn of $class("log-out")){
    btn.addEventListener("click", async () => {
        await signOut(auth);
    });
}


$btn("delete-btn").addEventListener("click", async() => {
    if(theArticle != undefined && confirm("Do you want to delete this article?")){
        await deleteArticle(theArticle.id);
        setArticle(undefined);
        showToast("The article is deleted.")
        appManager.navigateTo('/');
    }
});

$btn("download-btn").addEventListener("click", () => {
    const contentText = makeContentText();
    const fileName = downloadMarkdownFile(contentText)
    msg(`save:${fileName}`);
});

$btn("publish-btn").addEventListener("click", async () => {
    if(thumbnailBlob == undefined && theArticle == undefined){
        showToast("Create a thumbnail before publishing.");
        return;
    }

    const params = makeArticleData();
    await createArticle(params);

    showToast("The simulation successfully uploaded!");
});

export async function initFirebase() {

    $btn("nickname-btn").addEventListener("click", async(_:PointerEvent)=>{
        await onRegisterNicknameBtn();
    });
    $dlg("nickname-dlg").addEventListener("cancel", onCancelNicknameDlg);

    initArticle();
    initTagInput();
    initComboBox();
}